import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ListaPacientes from '../components/Pacientes/ListaPacientes.vue'
import Paciente from '../components/Pacientes/Paciente.vue'
import store from '../store'

const routes = [
  {
    path: '/login',
    component: () => import('../components/Layouts/LoginLayout.vue'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('../components/Pages/Login.vue'),
        meta: { requiresAuth: false }
      }
    ]
  },

  // Redirigir raíz a login
  {
    path: '/',
    redirect: '/login'
  },

  // Área autenticada
  {
    path: '/dashboard',
    component: () => import('../components/Layouts/AuthLayout.vue'),
    meta: { requiresAuth: true },
    redirect: '/dashboard/admin/pacientes', 
    children: [
      {
        path: 'admin',
        name: 'adminDashboard',
        component: () => import('../components/Pages/DashboardAdmin.vue'),
        // redirect: '/dashboard/admin/listaPacientes',
        children: [
          { 
            path: 'pacientes',
            name:'pacientes', 
            component: () => import('../components/Pacientes/ListaPacientes.vue') 
          },
          { 
            path: 'personal',
            name:'personal', 
            component: () => import('../components/Personal/ListaPersonal.vue') 
          },
          { 
            path: 'consultas',
            name:'consultas', 
            component: () => import('../components/Consultas/ListaConsultas.vue') 
          },
          { 
            path: 'agenda',
            name:'agenda', 
            component: () => import('../components/Agenda/Agenda.vue') 
          },
        ]
      }
    ]
  },
  // Página no encontrada → login
  {
    path: '/:catchAll(.*)*',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['isAuthenticated']
  const usuario = store.getters.getUsuario

  // Rutas protegidas
  if (to.meta.requiresAuth) {
    if (!isAuthenticated) {
      return next('/login')
    }

    if (!usuario || !usuario.rol) {
      store.dispatch('cerrarSesion')
      return next('/login')
    }

    // Validación de rol
    if (to.meta.rol && usuario.rol !== to.meta.rol) {
      return next('/dashboard')
    }

    return next()
  }

  // Evitar volver a login si ya está autenticado
  if (to.name === 'login' && isAuthenticated) {
    return next('/dashboard')
  }

  next()
})


export default router
